import { getApi } from '../../../api/utils/get'
import getJwtSelect from '../../../jwt/selectors/get'
import logSystemUtil from '../../../logs/redux/actions/log'
import isConnectedNetworkSelect from '../../../network/selectors/is-connected'
import getCurrentIdProfileSelect from '../../../profile/redux/selectors/get-current-id'
import { getCurrentOrCustomerIdProfileSelect } from '../../../profile/redux/selectors/get-current-or-customer-id'
import createReduxAction from '../../../redux/actions/create'
import { REDUX_DOMAIN_LIST_KEY, REDUX_KEY } from '../../../redux/constants/key'
import REDUX_OPTION from '../../../redux/constants/option'
import { QUERY_PARAMETER } from '../../../redux/constants/query-params'
import REDUX_STATUS from '../../../redux/constants/status'
import getReduxSelector from '../../../redux/selectors/get'
import isLoadingSelect from '../../../redux/selectors/is-loading'
import getDomainPathFromPathReduxUtil from '../../../redux/utils/get-domain-path-from-path'
import getPathFromDomainPathReduxUtil from '../../../redux/utils/get-path-from-domain-path'
import getQueryDomainListPathReduxUtil from '../../../redux/utils/get-query-domain-list-path'
import loadSuccessReduxAction from '../../../redux/actions/load/load-success'
import loadErrorReduxAction from '../../../redux/actions/load/load-error'
import loadingReduxAction from '../../../redux/actions/load/loading'
import { getObjectUtil, isEmptyUtil } from 'packages/src'

const queryString = require('query-string')

// function shuffleDomainListDataOrderAction ({ domainListPath }) {
//   return (dispatch, getState) => {
//     const domainPath = getDomainPathFromPathReduxUtil(domainListPath)
//     const domainMapPath = getDomainMapDataPathReduxUtil(domainPath)
//     const domainListDataPath = getDomainListDataPathReduxUtil(domainListPath)
//     const domainListIds = getInstanceIdsReduxSelector(
//       domainMapPath,
//       domainListDataPath
//     )(
//       getState())
//     const newDomainListIds = shuffleArrayUtil(domainListIds)
//
//     dispatch(setReduxAction({
//       type: 'REDUX_SHUFFLE_DOMAIN_LIST_DATA_ORDER',
//       payload: {
//         path: domainListDataPath,
//         value: newDomainListIds
//       }
//     }))
//   }
// }

export default function loadDomainReduxAction (action) {
  return async (dispatch, getState) => {
    const profileId = getCurrentOrCustomerIdProfileSelect(getState())
    const { payload } = action
    const {
      path,
      options = {}
    } = payload

    if (!profileId && !options[REDUX_OPTION.NO_AUTH_NEEDED]) {
      logSystemUtil('loadDomainReduxAction').warn('no profile')
      return
    }

    const currentProfileId = getCurrentIdProfileSelect(getState())
    let {
      domainListPath
    } = payload

    let {
      endpoint,
      query = {}
    } = payload

    if (query.q) {
      domainListPath = getQueryDomainListPathReduxUtil(domainListPath, query.q + '')
    }
    if (query.tag) {
      domainListPath = getQueryDomainListPathReduxUtil(domainListPath, query.tag + '')
    }
    const logPrefix = `[path=${path}][domainListPath=${domainListPath}]`
    logSystemUtil('loadDomainReduxAction').debug(`${logPrefix}[start] options: `, options)

    // If it's already loading, no-op
    if (
      path &&
      isLoadingSelect(path)(getState()) &&
      !getObjectUtil(options, REDUX_OPTION.IS_FORCED)
    ) {
      logSystemUtil('loadDomainReduxAction').debug(`${logPrefix}[noop] domain already loading`)
      return
    }

    // If it's already loading, no-op
    if (
      domainListPath &&
      isLoadingSelect(domainListPath)(getState()) &&
      !getObjectUtil(options, REDUX_OPTION.IS_FORCED)
    ) {
      logSystemUtil('loadDomainReduxAction').debug(`${logPrefix}[noop] domain list already loading`)
      return
    }

    if (!isConnectedNetworkSelect(getState())) {
      logSystemUtil('loadDomainReduxAction').debug(`${logPrefix}[noop] not connected`)
      return
    }

    dispatch(
      loadingReduxAction({
        type: action.type,
        payload: {
          path,
          domainListPath
        }
      })
    )

    try {
      const jwt = getJwtSelect(getState())
      const updatedAt = (
        query.updatedAt ||
        options[REDUX_OPTION.IGNORE_UPDATED_AT] ||
        options[REDUX_OPTION.GET_PAGINATION_LAST_ITEM_ID]
      )
        ? null
        : getObjectUtil(getState(), `${domainListPath}.${REDUX_KEY.UPDATED_AT}`)

      if (updatedAt) {
        query = {
          ...query,
          updatedAt
        }
      }

      if (options[REDUX_OPTION.GET_PAGINATION_LAST_ITEM_ID] && domainListPath) {
        const lastId = getReduxSelector(domainListPath)(getState())?.[REDUX_DOMAIN_LIST_KEY.LAST_ID]

        if (lastId) {
          const lastInstance = getObjectUtil(
            getState(),
            getPathFromDomainPathReduxUtil(getDomainPathFromPathReduxUtil(domainListPath), lastId)
          )

          if (lastInstance) {
            query = {
              ...query,
              [QUERY_PARAMETER.LAST_ID]: lastId
            }
          }
        }
      }

      if (!isEmptyUtil(query)) {
        const queryStr = queryString.stringify({
          ...query
        })
        endpoint += `?${queryStr}`
      }

      let fetchOptions
      if (profileId !== currentProfileId) {
        fetchOptions = {
          headers: {
            'x-client-id': profileId
          }
        }
      }
      const response = await getApi({
        endpoint,
        jwt,
        fetchOptions
      })

      if (!response) {
        logSystemUtil('loadDomainReduxAction').warn(`${logPrefix} no data for endpoint: `, endpoint)
        return
      }
      const responseData = (
        response.data && Object.values(response.data)[0]
      )

      logSystemUtil('loadDomainReduxAction').debug(`${logPrefix} responseData=`, responseData)

      // Add the instances
      const hasInstances = (
        Array.isArray(responseData) &&
        responseData.length
      )
      if (hasInstances) {
        dispatch(createReduxAction({
          type: action.type + '_CREATE_AFTER_LOAD',
          payload: {
            data: responseData,
            status: REDUX_STATUS.SUCCESS,
            domainListPath,
            options
          }
        }))
      }

      dispatch(loadSuccessReduxAction({
        type: action.type,
        payload: {
          path,
          domainListPath
        }
      }))

      // if (
      //   hasInstances &&
      //   options[REDUX_OPTION.SHUFFLE_DOMAIN_LIST_DATA_ORDER] &&
      //   domainListPath
      // ) {
      //   dispatch(shuffleDomainListDataOrderAction({
      //     domainListPath
      //   }))
      // }

      return response
    } catch (error) {
      logSystemUtil('loadDomainReduxAction').error(`${logPrefix} error=`, error)
      dispatch(loadErrorReduxAction({
        type: action.type,
        payload: {
          path,
          domainListPath,
          error
        }
      }))
      throw error
    }
  }
}
